import _ from 'underscore';

export class PartitionStrategy {
  /**
   * Partition strategy is used to put certain cache items into separated storage
   * cache with standalone quota. A PartitionStrategy instance has a TimeAwareCache
   * and a condition method
   * @param {Object} options -
   * @param {TimeAwareCache} options.cache - Limit of the default partition
   * @param {PartitionConditionCallback} options.condition - The conditional partitions
   */
  constructor({
    cache = null,
    condition = _.constant(true),
  } = {}) {
    this.options = { cache, condition };
  }

  /**
   * Initialize a cache manager for applying the partition strategy
   * @param {ClientCacheManager} cacheManager - The cache manager to initialize
   * @returns {void}
   */
  initializeCacheManager(/* cacheManager */) {
  }

  /**
   * The storage cache
   * @type {TimeAwareCache}
   */
  get cache() {
    return this.options.cache;
  }

  /**
   * Condition for this partition
   * @param {ClientCacheManager} cacheManager - The client side cache manager
   * @param {ClientCacheKey} key - The cache key
   * @returns {boolean} - True if the key falls into this partition
   */
  condition(cacheManager, key) {
    /**
     * @callback {PartitionConditionCallback}
     * @param {ClientCacheManager} cacheManager - The client side cache manager
     * @param {ClientCacheKey} key - The cache key
     * @returns {boolean} - True if the key falls into this partition
     */
    return this.options.condition(cacheManager, key);
  }
}
